import { render } from "./StarFlightCanvas.vue?vue&type=template&id=042e8bfc&scoped=true"
import script from "./StarFlightCanvas.vue?vue&type=script&lang=js"
export * from "./StarFlightCanvas.vue?vue&type=script&lang=js"

import "./StarFlightCanvas.vue?vue&type=style&index=0&id=042e8bfc&scoped=true&lang=css"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/amane_dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042e8bfc"]])

export default __exports__